module.exports = __webpack_public_path__ + "img/do.7ca8e87e.svg";